import {connect} from 'react-redux';
import axios from 'axios';
import {Alert, Linking, Platform} from "react-native"

import PaySatiaScreen from '../PaySatiaScreen';
import {typeExport} from "../../../../../redux/store/type";
import store from "../../../../../redux/store";
import i18n from "../../../../../I18n/i18n";
import {Tools} from "../../../../../tools/Tools";
import HMAlert from "../../../../../customviews/HMAlert";
import {serviceActionSetWallet} from "../../../splash/action/ActionSplashSatiaScreen";

const mapStateToProps = (state) => ({
    CancelToken: state.reducerPaySatiaScreen.CancelToken,
    results: state.reducerPaySatiaScreen.results,
    NoInternetDialog: state.reducerPaySatiaScreen.NoInternetDialog,
    isLoading: state.reducerPaySatiaScreen.isLoading,

    CartList: state.reducerSplashSatiaScreen.CartList,
    PriceAll: state.reducerSplashSatiaScreen.PriceAll,
    DiscountAll: state.reducerSplashSatiaScreen.DiscountAll,

    token: state.reducerSplashSatiaScreen.token,
    user: state.reducerSplashSatiaScreen.user,
    wallet: state.reducerSplashSatiaScreen.wallet,
    DataSplashSatiaScreen: state.reducerSplashSatiaScreen,

});

const mapDispatchToProps = (dispatch) => ({
    callService: (url, params, type, typeConnection, selectedIndex, token) => dispatch(callWebservice(url, params, type, typeConnection, selectedIndex, token)),
    callserviceActionRefresh: () => dispatch(serviceActionRefresh()),
    callServiceSetWallet: (data, typeWallet) => dispatch(serviceActionSetWallet(data, typeWallet)),


})

const getDataDisatch = (dispatch, url, params, type, typeConnection, selectedIndex, token) => {


    // const formData = new FormData();
    //
    //
    // formData.append('orders', params);
    // const config = {
    //     headers: {
    //         "Content-Type": "multipart/form-data; charset=utf-8;",
    //         "Authorization":  token,
    //
    //     }
    // };

    // axios.post(baseUrl + url, formData, config).then(function (response) {

    //     // switch (type) {
    //     //
    //     //     case TypeSetDataPaySatiaScreen:
    //     //         dispatch(serviceActionSuccess(response.data))
    //     //         break;
    //     //     default:
    //     //
    //     // }
    //
    // })
    //     .catch(function (error) {
    //         dispatch(serviceActionError(error))
    //     });
    let CancelToken = axios.CancelToken;

    let cancel = null;

//    CancelToken = CancelToken.source();

    /*    if (Platform.OS==="web")
            dispatch(serviceActionPending());*/

    axios(
        {
            url: typeExport._baseUrlSatia + url + params,
            method: typeConnection,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                //  "Authorization": token,
            },
            timeout: typeExport._TIMEOUT,
            //   CancelToken: CancelToken.token
            cancelToken: new CancelToken(function executor(c) {
                dispatch(serviceActionPending(c));

                // An executor function receives a cancel function as a parameter
                cancel = c;
            })
        }
    ).then(response => {
        switch (type) {

            case typeExport.TypeSetDataPaySatiaScreen:
                dispatch(serviceActionSuccess(response.data))

                if (response.data.status) {
                  //  dispatch(serviceActionSuccess(response.data))

                    if (response.data.Url2)
                        Tools.GoLink(response.data.Url2,"self")

                    // alert(response.data.Url2)

                    // if (selectedIndex===0){
                    //     Linking.openURL(response.data.url).catch(err => console.error('An error occurred', err))
                    //
                    // }
                    // else {
                    //    // alert(response.data.message)
                    // }


                    //Linking.openURL(response.data.Url2).catch(err => console.error('An error occurred', err))

                    // switch (selectedIndex) {
                    //     case 0:
                    //         Linking.openURL(response.data.url).catch(err => console.error('An error occurred', err))
                    //
                    //         break;
                    //
                    //     case 1:
                    //
                    //
                    //         break;
                    //
                    //     case 2:
                    //         // wallet = this.props.wallet - (discount !== null ? (PriceAll - (PriceAll * (discount.percent / 100))) : PriceAll)
                    //         // this.props.callserviceSetWallet(wallet)
                    //         break;
                    // }


                }
                else {
                    //dispatch(serviceActionError("error",response))
                    HMAlert(
                        i18n.t('constant.message'),
                        response.data.message,
                        [
                            {
                                text: i18n.t('constant.ok'), onPress: () => {
                                   // NavigationService.Pop();
                                }


                            },

                        ],
                        {cancelable: true}
                    )

                }


                break;
            default:
        }
    }).catch((e) => {
   /*     HMAlert(
            i18n.t('constant.message'),
            i18n.t('constant.retry'),
            [
                {
                    text: i18n.t('constant.ok'), onPress: () => {
                        NavigationService.Pop();
                    }


                },

            ],
            {cancelable: false}
        )*/
        dispatch(serviceActionError(e))
    })
}


export const callWebservice = (url, params, type, typeConnection, selectedIndex, token) => {

    return dispatch => {
        // NetInfo.isConnected.fetch().then(isConnected => {
        //     if (isConnected) {
        //         getDataDisatch(dispatch, url, params, type, typeConnection, selectedIndex,token);
        //     }
        //     else {
        //         dispatch(serviceActionError("No Internet Connection"));
        //     }
        // });


        if (store.getState().reducerSplashSatiaScreen.Connection) {
            getDataDisatch(dispatch, url, params, type, typeConnection, selectedIndex, token);
        } else {
            dispatch(serviceActionError("No Internet Connection"));
        }
        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, url, params, type, typeConnection, selectedIndex, token);
        //         }
        //         else {
        //             dispatch(serviceActionError("No Internet Connection"));
        //         }
        //     }
        // )
    }
}


export const serviceActionPending = (CancelToken) => ({
    type: typeExport.PaySatiaScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    results: null,
    CancelToken: CancelToken
})

export const serviceActionError = (error) => ({
    type: typeExport.PaySatiaScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    isLoading: false,
    error: error
})

export const serviceActionSuccess = (data) => ({
    type: typeExport.PaySatiaScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    isLoading: false,
    results: data,


})

export const serviceActionRefresh = () => ({
    type: typeExport.PaySatiaScreen_SERVICE_REFRESH,
    NoInternetDialog: false,
    isLoading: false,
    results: null
})
export default connect(mapStateToProps, mapDispatchToProps)(PaySatiaScreen);
